<template>
  <Button as-child class="bg-primary text-md h-10">
    <a href="https://xeo.vision/contact/" target="_blank" rel="noopener">
      {{ $t('pages.index.info.contact_button') }}
    </a>
  </Button>
</template>
